export const TIME_INTERVAL = 5 * 60 * 1000;
